import { HubConnection } from '@microsoft/signalr';
import { InjectionKey } from 'vue';
import { SeverityType } from '@/api/generator';
import { NotificationType } from '@/components/notifications/types';

export const DeviceStatusHubKey: InjectionKey<HubConnection> = Symbol('DeviceStatusHubKey');

export const severityOrder: SeverityType[] = [
  'ErrorFatalDevice',
  'ErrorFatal',
  'ErrorHigh',
  'ErrorLow',
  'WarningHigh',
  'WarningLow',
  'Hint',
  'Unknown',
];

/**
 * Maximum acceptable severity level for measurements.
 * Higher severities (ErrorLow, ErrorHigh, ErrorFatal, ErrorFatalDevice) are unacceptable.
 */
export const MAX_ACCEPTABLE_SEVERITY: SeverityType = 'WarningHigh';

export const severitiyNotificationTypeMapping: Record<SeverityType, NotificationType> = {
  Unknown: 'warning',
  Hint: 'info',
  WarningLow: 'warning',
  WarningHigh: 'warning',
  ErrorLow: 'error',
  ErrorHigh: 'error',
  ErrorFatal: 'error',
  ErrorFatalDevice: 'error',
};
